import { Objeto } from '../../Services/Models';

class SignIn {
    constructor() {
        try {
            var Resultado = localStorage.getItem("ContextSignIn");

            try
            {
                var Objeto = JSON.parse(localStorage.getItem("ContextSignIn") ?? "") as { token: string, pessoa: Objeto.Pessoa, UltimoGrupoDeEmpresasAcessado: string|undefined }
                if (Objeto && Objeto.UltimoGrupoDeEmpresasAcessado && Objeto.UltimoGrupoDeEmpresasAcessado?.length > 1)
                {
                    localStorage.setItem("ContextSignIn", JSON.stringify(<{ token: string, pessoa: Objeto.Pessoa, UltimoGrupoDeEmpresasAcessado: number|undefined }>{
                        token: "",
                        pessoa: {
                            id: 0,
                            cpf: "",
                            nome: "",
                            natureza: 0,
                            dataDeNascimento: new Date(),
                            nacionalidade: null,
                            emails: [],
                            documentoPessoal: null,
                            rg: null,
                            creci: null,
                            estadoCivil: 0,
                            documentoDeEstadoCivil: null,
                            regimeDeBens: null,
                            necessarioAssinaturaDoConjuge: false,
                            conjuge: null,
                            endereco: null,
                            documentoEndereco: null,
                            telefones: [],
                            ocupacao: null
                        },
                        UltimoGrupoDeEmpresasAcessado: 0
                    }));
                }
            }
            catch
            {
                
            }
        }
        catch {
            localStorage.setItem("ContextSignIn", JSON.stringify(<{ token: string, pessoa: Objeto.Pessoa, UltimoGrupoDeEmpresasAcessado: number|undefined }>{
                token: "",
                pessoa: {
                    id: 0,
                    cpf: "",
                    nome: "",
                    natureza: 0,
                    dataDeNascimento: new Date(),
                    nacionalidade: null,
                    emails: [],
                    documentoPessoal: null,
                    rg: null,
                    creci: null,
                    estadoCivil: 0,
                    documentoDeEstadoCivil: null,
                    regimeDeBens: null,
                    necessarioAssinaturaDoConjuge: false,
                    conjuge: null,
                    endereco: null,
                    documentoEndereco: null,
                    telefones: [],
                    ocupacao: null
                },
                UltimoGrupoDeEmpresasAcessado: 0
            }));
        }
    }
    /* Sobre esta função *//**
     * Armazena um registro no repositório local e no cache da aplicação
     * @param {string} Registro Informe o registro a ser armazenado
     **/
    public setContext(Registro: { token: string, pessoa: Objeto.Pessoa, UltimoGrupoDeEmpresasAcessado: number|undefined } | undefined): any {
        if (true)
        {
            return 0
        }
        else
        {
            return 0
        }
    };
    /* Sobre esta função *//**
     * Retorna o registro armazenado no repositório local
     **/
    public getContext():any {
        return 0
    };
};

export default new SignIn();